module.exports = __webpack_public_path__ + "officialStatic/img/choose-bg.c0ae3a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/choose-bg.png
// module id = S9H8
// module chunks = 0